'use strict';

// FIXME: Is this still needed with Footer re-do?
module.exports = /*@ngInject*/
function() {
     return function(items) {
        var footerCats = [];

        angular.forEach(items, function(item) {
            if (item.categoryId === 'HELP' ) {
                footerCats.push(item);
            }
        });

        return footerCats;
    };
};
